import React, { useEffect, useState } from 'react';
import { createConnectAccount } from '../api/stripe.api';

export default function Reauth() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function refreshOnboarding() {
      try {
        const result = await createConnectAccount();

        if (result.url) {
          // Redirect to Stripe onboarding
          window.location.href = result.url;
        } else if (result.onboardingComplete) {
          // Already complete, redirect to dashboard
          window.location.href = '/myguest';
        } else {
          setError('Failed to generate onboarding link');
          setLoading(false);
        }
      } catch (err) {
        setError(
          err?.response?.data?.error ||
            err?.message ||
            'Failed to refresh onboarding',
        );
        setLoading(false);
      }
    }

    refreshOnboarding();
  }, []);

  if (loading) {
    return (
      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card">
              <div className="card-body text-center py-5">
                <div className="spinner-border text-primary mb-3" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p>Refreshing your onboarding session...</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card">
              <div className="card-body">
                <div className="alert alert-danger">
                  <i className="fas fa-exclamation-circle me-2"></i>
                  <strong>Error</strong>
                  <p className="mb-0 mt-2">{error}</p>
                </div>
                <a href="/myguest" className="btn btn-secondary">
                  Go to Host Dashboard
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
}

Reauth.propTypes = {};
